export default __webpack_public_path__ + "static/media/584.756b994f.jpg";